import { RegisterTypeEnum } from '@shared/enum/RegisterType.Enum';
import { RegisterTypeConfig } from '@rift/shared/Settings.RegisterConfig';

export const getDisplayName = (value: RegisterTypeEnum): string => {
    return RegisterTypeConfig[value].displayName;
}
